function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinLocation = function SvgPinLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 5.1c-8 0-14.4 6.5-14.4 14.4s11 21 14.4 24.4c3.5-3.5 14.4-16.5 14.4-24.4S32 5.1 24 5.1z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 19.5,
    r: 10.9,
    style: {
      fill: "#04cbaa"
    }
  }));
};
export default SvgPinLocation;